module.exports = __webpack_public_path__ + "img/network-unknown.3cb02c1.svg";